<template>
  <div class="relative flex items-center !h-32 px-6">
    <div class="font-normal text-[#707C8E]">
      <h3 class="text-base font-medium 2xl:text-lg">
        Total GHG Emissions
      </h3>
      <div class="mt-2">
        <GhgEmissionTotal
          :emissions="emissions"
          :metrics-change="metricsChange"
        />
      </div>
    </div>
    <svg
      class="absolute right-0 w-12 h-24 top-4"
      viewBox="0 0 65 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_440_566)">
        <path
          d="M37.9165 81.25H92.0832V102.917C92.0832 105.79 90.9418 108.545 88.9102 110.577C86.8785 112.609 84.123 113.75 81.2498 113.75H48.7498C45.8767 113.75 43.1212 112.609 41.0895 110.577C39.0579 108.545 37.9165 105.79 37.9165 102.917V81.25Z"
          stroke="#E2E5E8"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65 48.75C65 40.1305 61.5759 31.864 55.481 25.769C49.386 19.6741 41.1195 16.25 32.5 16.25H16.25V27.0833C16.25 35.7029 19.6741 43.9694 25.769 50.0643C31.864 56.1592 40.1305 59.5833 48.75 59.5833H65"
          stroke="#218579"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65 59.5833C65 50.9638 68.4241 42.6973 74.519 36.6024C80.614 30.5074 88.8805 27.0833 97.5 27.0833H113.75V32.5C113.75 41.1195 110.326 49.386 104.231 55.481C98.136 61.5759 89.8695 65 81.25 65H65"
          stroke="#E2E5E8"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65 81.25V48.75"
          stroke="#E2E5E8"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_440_566">
          <rect
            class="size-24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'TotalEmissionsCardNew',

  props: {
    emissions: {
      type: Number,
      required: true,
    },
    metricsChange: {
      type: [Number, String],
      required: true,
    },
  },
}
</script>
